import { render } from "./PricingModal.vue?vue&type=template&id=4283af4c&scoped=true"
import script from "./PricingModal.vue?vue&type=script&lang=js"
export * from "./PricingModal.vue?vue&type=script&lang=js"

import "./PricingModal.vue?vue&type=style&index=0&id=4283af4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4283af4c"]])

export default __exports__